import React, { useRef } from 'react';
import PropTypes from '../../node_modules/prop-types/index.js';
import NavigationContext from './NavigationContext.js';

var NavigationProvider = function NavigationProvider(_ref) {
  var isSignedIn = _ref.isSignedIn,
      children = _ref.children;
  var mainNavWrapperRef = useRef();
  var subNavWrapperRef = useRef();
  return /*#__PURE__*/React.createElement(NavigationContext.Provider, {
    value: {
      isSignedIn: isSignedIn,
      mainNavWrapperRef: mainNavWrapperRef,
      subNavWrapperRef: subNavWrapperRef
    }
  }, children);
};

process.env.NODE_ENV !== "production" ? NavigationProvider.propTypes = {
  isSignedIn: PropTypes.bool,
  children: PropTypes.node.isRequired
} : void 0;
NavigationProvider.defaultProps = {
  isSignedIn: false
};
var NavigationProvider$1 = NavigationProvider;

export { NavigationProvider$1 as default };
